import { pricingContent } from '@/config/marketing-content/pricing'
import { FaqSection } from '@/components/marketing/faq-section'
import { MarketingHero } from '@/components/marketing/marketing-hero'
import { PricingTierCarousel } from '@/components/marketing/pricing-tier-carousel'
import { SectionHeader } from '@/components/marketing/section-header'

export function PricingPage() {
  return (
    <main>
      <MarketingHero
        className="marketing-hero--compact"
        eyebrow={pricingContent.eyebrow}
        title={pricingContent.heroTitle}
        lead={pricingContent.heroLead}
      />

      <section className="pricing-plans-section">
        <PricingTierCarousel tiers={pricingContent.tiers} />
      </section>

      <section className="marketing-section pricing-value-props-section">
        <div className="marketing-container space-y-10">
          <SectionHeader
            eyebrow={pricingContent.valuePropsEyebrow}
            title={pricingContent.valuePropsTitle}
            lead={pricingContent.valuePropsLead}
            align="center"
          />
          <div className="pricing-value-props-grid">
            {pricingContent.valueProps.map((item) => (
              <article key={item.title} className="pricing-value-prop-card">
                <h3 className="pricing-value-prop-card__title">{item.title}</h3>
                <p className="pricing-value-prop-card__description">{item.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {pricingContent.faqItems.length ? (
        <FaqSection
          eyebrow={pricingContent.faqEyebrow}
          title={pricingContent.faqTitle}
          lead={
            <>
              {pricingContent.faqLead}{' '}
              <a href={pricingContent.faqLeadLink.href} className="faq-lead__link">
                {pricingContent.faqLeadLink.label}
              </a>
              .
            </>
          }
          items={pricingContent.faqItems}
          variant="cards"
        />
      ) : null}
    </main>
  )
}
